import { BlockStack, Card, Text, SkeletonDisplayText, InlineStack } from '@shopify/polaris'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { numberFormater, percentageFormatter } from '../../../../utils/formater'

function AnalyticsSection({ analyticsData, isLoading }) {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <Card padding='400'>
        <BlockStack gap='400'>
          <SkeletonDisplayText size="small" />
          <SkeletonDisplayText size="small" />
          <SkeletonDisplayText size="small" />
        </BlockStack>
      </Card>
    )
  }

  return (
    <Card padding='400'>
      <BlockStack gap='200'>
        <Text as="h2" variant="headingMd">
          {t('PerformanceSection.lastDaysPerformance', { days: 7 })}
        </Text>

        <InlineStack align='space-between'>
          <Text>{t('PerformanceSection.totalSessions')}</Text>
          <Text variant="bodyLg" as="p">{numberFormater(analyticsData?.totalSessions ?? 0)}</Text>
        </InlineStack>

        <InlineStack align='space-between'>
          <Text>{t('PerformanceSection.totalSessionsWithRecommendations')}</Text>
          <Text variant="bodyLg" as="p">{numberFormater(analyticsData?.sessionsWithRecommendationViews ?? 0)}</Text>
        </InlineStack>

        <InlineStack align='space-between'>
          <Text>{t('PerformanceSection.viewRate')}</Text>
          <Text variant="bodyLg" as="p">{percentageFormatter(analyticsData?.viewRate ?? 0)}</Text>
        </InlineStack>

        <InlineStack align='space-between'>
          <Text>{t('PerformanceSection.interactionRate')}</Text>
          <Text variant="bodyLg" as="p">{percentageFormatter(analyticsData?.interactionRate ?? 0)}</Text>
        </InlineStack>
      </BlockStack>
    </Card>
  )
}

export default AnalyticsSection